module.exports = "/fonts/Gotham-Book.woff?7041cf9f956318c06ebc4f90f6878d20";